<template>
  <div>
    <g-master :name="master.endpoint"
              :endpoint="master.endpoint"
              :tableSetup="master.tableSetup"
              :modalFieldsSetup="master.modalFieldsSetup"
              :parentData="parentData"
    >
      <template slot="masterModal" slot-scope="{record}">
        <a-row :gutter="[16,16]">
          <a-col v-bind="colOptions">
            <g-dropdown endpoint="hierarchy_lookup"
                        :label="$t('Numero de Instancia')"
                        style="width: 100%"
                        :formItemConfig="fiOptions"
                        :decorator="['type_instance', { rules: [{ required: false, message: 'Valor requerido'}] }]"
                        :params="tipo_instancia">
            </g-dropdown>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item v-bind="fiOptions" :label="$t('Fecha instancia')">
              <a-date-picker style="width: 100%"
                             type="date"
                             valueFormat="Y-MM-DD HH:mm:ss"
                             v-decorator="['date_instance', { rules: [{ required: false, message: 'Valor requerido'}] }]"
              ></a-date-picker>
            </a-form-item>
          </a-col>
          <a-col v-bind="colOptions">
            <a-form-item :label="$t('Dictamen / Observaciones')" v-bind="fiOptions">
              <a-textarea autoSize
                          v-decorator="['obs_instance', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
            </a-form-item>
          </a-col>
        </a-row>
      </template>
    </g-master>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane tab="Diagnosticos" key="1">
        <seguridad-salud-diagnosis-instance v-if="idInstance" :id_instance="idInstance"/>
        <span v-else>Seleccione una instancia para ver más.</span>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
  export default {
    props: ['id_case'],
    data () {
      return {
        tipo_instancia: {
          h_lookup_type: 'TIPO_INSTANCIA',
          use_code: true
        },
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        colOptions: {xs: 24, sm: 24},
        master: {
          endpoint: 'instance_case',
          tableSetup: {
            allowSelect: true,
            selectedRows: [],
            tableConfig: {
              rowKey: 'id_instance'
            },
            columns: [
              {title: 'Fecha instancia', dataIndex: 'date_instance_desc', sorter: true},
              {title: 'Numero de Instancia', dataIndex: 'destypeinstance', sorter: true},
              {title: 'Observación', dataIndex: 'obs_instance', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'type_instance'},
            {name: 'date_instance'},
            {name: 'obs_instance'}
          ]
        }
      }
    },
    computed: {
      parentData () {
        return {id_case: this.id_case}
      },
      idInstance () {
        return this.master.tableSetup.selectedRows.length > 0 ? this.master.tableSetup.selectedRows[0].id_instance : null
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/GestionHumana/SeguridadYSalud/InstanceCases.vue